import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Closed from "./pages/Closed";

// サービス休止中のため、全てのパスで休止のお知らせページを表示する
// 再開時はこのファイルを休止前の内容に戻す（git履歴参照）
function Router() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Closed />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default Router;
